import axios from 'axios'

export default {
  fetchPopularTags (params = {}) {
    return axios.get('/api/tag/get-popular-tags', { params })
  },
  fetchMyTags () {
    return axios.get('/api/tag/get-my-tags')
  },
  addProductToMyTags (payload) {
    return axios.post('/api/tag/add-product-to-my-tags', payload)
  },
  removeProductFromMyTags (payload) {
    return axios.delete('/api/tag/delete-product-from-my-tags', payload)
  },
  removeProductFromPopularTag (payload) {
    return axios.delete('/api/tag/delete-product-from-popular-tag', payload)
  },
  createPopularTag (payload) {
    return axios.post('/api/tag/create-popular-tag', payload)
  },
  createPopularTagHasProduct (payload) {
    return axios.post('/api/tag/create-popular-tag-has-product', payload)
  },
  deletePopularTag (payload) {
    return axios.delete('/api/tag/delete-popular-tag', payload)
  },
  updatePopularTag (id, payload) {
    return axios.patch(`/api/tag/popular-tag/${id}/update`, payload)
  },
  updateReorderPopularTags (payload) {
    return axios.patch('/api/tag/reorder-popular-tags-update', payload)
  },
  addProductToTagByDesignNumber(payload) {
    // Add module type for the centralized API
    const data = {
      ...payload,
      module: 'tag'
    }
    return axios.post('/api/add-product-by-design-number', data)
  }
}
